import { getPageDataApi, postRequest } from "../../Utils/commonApi";
import useBaseActions from "./base.actions";
import { BASE_API_PATHS } from "../../constants/apis.constants";

const useUserActions = () => {
  const { authTokens } = useBaseActions();

  const suspendAccount = ({ suspendOrArchive, clientId, statusValue, reason }) => {
    return getPageDataApi(BASE_API_PATHS.suspendAccount, authTokens, {
      SuspenedOrArchieve: suspendOrArchive,
      objId_Customer: clientId,
      StatusValue: statusValue,
      suspention_Reason: reason,
    });
  }

  const initiateSession = () => {
    return postRequest(authTokens, BASE_API_PATHS.initiateSession, {});
  }

  const resumeSession = ({ sessionId }) => {
    return getPageDataApi(BASE_API_PATHS.resumeSession, authTokens, {
      sessionId,
    });
  }

  return {
    suspendAccount,
    initiateSession,
    resumeSession,
  }
}

export default useUserActions;